/**
 * useOutreachContact — the entry-scoped contact edit (PATCH
 * .../outreach/contact). email/phone/whatsapp write the creator PROFILE and
 * are visible on every campaign that creator is in; emailOverride/sendTz are
 * this campaign entry only (see OutreachContactPatch's own field comments).
 *
 * Each Save is its own logical action, not a retryable multi-step flow like
 * the outreach import adapter's commitImport — so the Idempotency-Key is
 * minted fresh per mutate() call instead of held across calls.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { OutreachContactPatch } from '@discovr/types';
import { campaignKeys } from '../queryKeys';
import { patchOutreachContact } from '../api/outreachApi';

export function useOutreachContact(campaignId: string) {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { entryId: string; patch: OutreachContactPatch }>({
    mutationFn: ({ entryId, patch }) => patchOutreachContact(entryId, patch, crypto.randomUUID()),
    onSuccess: (_data, { entryId }) => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachRowsAll(campaignId) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachCounts(campaignId) });
      queryClient.invalidateQueries({ queryKey: campaignKeys.outreachThread(entryId) });
    },
  });
}
